var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1833_69278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6.25H27.5C28.4946 6.25 29.4484 6.64509 30.1517 7.34835C30.8549 8.05161 31.25 9.00544 31.25 10V20",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 16.25H26.25",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21H24",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 12.5C3.75 12.5 2.5 11.5625 2.5 10C2.5 9.00544 2.89509 8.05161 3.59835 7.34835C4.30161 6.64509 5.25544 6.25 6.25 6.25C7.24456 6.25 8.19839 6.64509 8.90165 7.34835C9.60491 8.05161 10 9.00544 10 10V30C10 30.9946 10.3951 31.9484 11.0983 32.6517C11.8016 33.3549 12.7554 33.75 13.75 33.75M13.75 33.75C14.7446 33.75 15.6984 33.3549 16.4017 32.6517C17.1049 31.9484 17.5 30.9946 17.5 30C17.5 28.4375 16.25 27.5 16.25 27.5H24M13.75 33.75H24",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 30L27.75 26.675C27.6724 26.6207 27.6094 26.5502 27.566 26.4692C27.5226 26.3882 27.5 26.2989 27.5 26.2083V23.5833C27.5 23.4286 27.5658 23.2803 27.6831 23.1709C27.8003 23.0615 27.9592 23 28.125 23H36.875C37.0408 23 37.1997 23.0615 37.3169 23.1709C37.4342 23.2803 37.5 23.4286 37.5 23.5833V26.1821C37.4997 26.272 37.4771 26.3607 37.434 26.4411C37.3909 26.5216 37.3285 26.5916 37.2516 26.6458L32.5 30Z",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 30L27.75 33.325C27.6724 33.3793 27.6094 33.4498 27.566 33.5308C27.5226 33.6118 27.5 33.7011 27.5 33.7917V36.4167C27.5 36.5714 27.5658 36.7197 27.6831 36.8291C27.8003 36.9385 27.9592 37 28.125 37H36.875C37.0408 37 37.1997 36.9385 37.3169 36.8291C37.4342 36.7197 37.5 36.5714 37.5 36.4167V33.8179C37.4999 33.7277 37.4775 33.6388 37.4344 33.5581C37.3913 33.4773 37.3287 33.407 37.2516 33.3527L32.5 30Z",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1833_69278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.4b38934d44e055ae52356d6d89baad69.svg";
export { ForwardRef as ReactComponent };